/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Investments1Inputs */

const en_usermanagement_permissions_investments1 = /** @type {(inputs: Usermanagement_Permissions_Investments1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investments`)
};

/**
* | output |
* | --- |
* | "Investments" |
*
* @param {Usermanagement_Permissions_Investments1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_investments1 = /** @type {((inputs?: Usermanagement_Permissions_Investments1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Investments1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_investments1(inputs)
});
export { usermanagement_permissions_investments1 as "userManagement_permissions_investments" }